import { useTranslation } from "react-i18next";
import innoDelRe from "../assets/roomsAssets/inno.png";
import barbiere from "../assets/roomsAssets/barbiere.png";
import molinara from "../assets/roomsAssets/molinara.JPG";
import osteria from "../assets/roomsAssets/osteria.JPG";
import matrimonio from "../assets/roomsAssets/matrimonio.JPG";

const useTranslatedRooms = () => {
  const { t } = useTranslation();

  const rooms = [
    {
      name: t("roomsInfoSingles.0.name"),
      label: t("roomsInfoSingles.0.title"),
      numero: "room1",
      beds: t("roomsInfoSingles.0.beds"),
      image: innoDelRe,
      persone: 4,
    },
    {
      name: t("roomsInfoSingles.1.name"),
      label: t("roomsInfoSingles.1.title"),
      numero: "room2",
      beds: t("roomsInfoSingles.1.beds"),
      image: barbiere,
      persone: 3,
    },
    {
      name: t("roomsInfoSingles.2.name"),
      label: t("roomsInfoSingles.2.title"),
      numero: "room3",
      beds: t("roomsInfoSingles.2.beds"),
      image: osteria,
      persone: 3,
    },
    {
      name: t("roomsInfoSingles.3.name"),
      label: t("roomsInfoSingles.3.title"),
      numero: "room4",
      beds: t("roomsInfoSingles.3.beds"),
      image: molinara,
      persone: 2,
    },
    {
      name: t("roomsInfoSingles.4.name"),
      label: t("roomsInfoSingles.4.title"),
      numero: "room5",
      beds: t("roomsInfoSingles.4.beds"),
      image: matrimonio,
      persone: 3,
    },
  ];

  return rooms;
};

export default useTranslatedRooms;
